import { TextField } from "@mui/material";
import { formatMoney, maxSpendCents } from "./marketingFormat";

export default function DeliveryFields({ plan, currency, subject }) {
  const { fields, set } = plan;
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <TextField
          label={`Daily budget${currency ? ` (${currency})` : ""}`}
          value={fields.budget}
          onChange={(e) => set("budget")(e.target.value)}
          size="small"
          helperText="Minimum 1.00"
        />
        <TextField
          label="Days to run"
          value={fields.days}
          onChange={(e) => set("days")(e.target.value)}
          size="small"
          error={!plan.daysValid}
          helperText="1 to 90 days from each start"
        />
      </div>
      <TextField
        label="Countries"
        value={fields.countries}
        onChange={(e) => set("countries")(e.target.value)}
        fullWidth
        size="small"
        error={!plan.countriesValid}
        helperText="Two-letter codes separated by commas, e.g. AU, NP"
      />
      <div className="grid grid-cols-2 gap-3">
        <TextField
          label="Youngest age"
          value={fields.ageMin}
          onChange={(e) => set("ageMin")(e.target.value)}
          size="small"
          error={!plan.agesValid}
          helperText="18 to 65"
        />
        <TextField
          label="Oldest age"
          value={fields.ageMax}
          onChange={(e) => set("ageMax")(e.target.value)}
          size="small"
          error={!plan.agesValid}
          helperText="65 means 65 and over"
        />
      </div>
      <div className="rounded bg-app-surface-alt p-3 text-sm">
        {plan.cents && plan.daysValid ? (
          <p>
            Up to <strong>{formatMoney(maxSpendCents(plan.cents, plan.dayCount), currency)}</strong>{" "}
            in total ({formatMoney(plan.cents, currency)} a day for {plan.dayCount} days).
          </p>
        ) : (
          <p>Enter a budget and number of days to see the most this {subject} can spend.</p>
        )}
        <p className="mt-1 text-app-text-secondary">
          The {subject} is created paused and does not spend. Start it from the Campaigns tab, and
          the run length counts from that moment.
        </p>
      </div>
    </>
  );
}
